import {Coordinates} from '@domain/coordinates';
import {inRange} from 'lodash-es';

export function isCoordinateOutOfRangeOfOtherCoordinate(coordinates: Coordinates, otherCoordinates: Coordinates, threshold: number = 30): boolean {
  const isHorizontallyOutOfRange = !inRange(coordinates.x, otherCoordinates.x - threshold, otherCoordinates.x + threshold);
  const isVerticallyOutOfRange = !inRange(coordinates.y, otherCoordinates.y - threshold, otherCoordinates.y + threshold);

  return isHorizontallyOutOfRange || isVerticallyOutOfRange;
}
